<template>
    <div class="hotkey-detail">
        <div class="col-md-12">
            <div class="form-group mb-1">
                <label class="form-label">Phím nóng <span class="text-danger">*</span></label>
                    <el-select disabled v-model="hotkey" clearable class="w-100" placeholder="Chọn phím nóng" multiple >
                        <el-option
                            v-for="item in phimNongDeFine"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id">
                            <span style="float: left">{{ item.value }}</span>
                        </el-option>
                    </el-select>
            </div>
        </div>

            <div class="col-md-12 mb-3 mt-5" v-for="id in hotkey" :key="id">
                <div class="form-group mb-1">
                    <label class="form-label">Chi tiết: {{ getHotKeyLabel(id) }} <span> :</span></label>
                    <textarea
                        disabled
                        class="form-control"
                        rows="5"
                        v-model="hot_key_detail[id]">
                    </textarea>
                </div>
            </div>
    </div>
</template>

<script>
export default {
    name: 'HotKeyDetail',
    props: {
        hotkey: {
            type: Array,
            required: true,
        },

        hot_key_detail: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            hot_key: [],
            phimNongDeFine: [
                {id: 1, value: "Tài chính", placeholder: "- Ai người quyết định chi trả tài chính?\n- Mức tài chính có phù hợp với gia đình không?\n- Mức tài chính có thể chi trả là bao nhiêu?"},
                {id: 2, value: "Phương pháp học", placeholder: "- Khách hàng lo ngại về hiệu quả phương pháp học?\n- Khách hàng cần thêm thông tin về phương pháp học?\n- Tại sao phải học tiếng anh?\n- Tại sao phải học tiếng Anh ở trung tâm này thay vì trung tâm khác?"},
                {id: 3, value: "Gia đình/Mối quan hệ", placeholder: "- Ai là người quyết định mua hàng?\n- Ai là người tác động, có tầm ảnh hưởng trong gia đình?\n- Khách hàng tin tưởng ai? (bạn bè, anh, chị, bố mẹ...)\n- Ý kiến phụ huynh?"},
                {id: 4, value: "Thời gian", placeholder: "- Khách hàng vướng lịch chưa học được? (VD: quân sự, chờ thi xong học, nghỉ hè...)\n- Tại sao phải học tiếng anh tại thời điểm này?"},
                {id: 5, value: "Định hướng học IELTS", placeholder: "- Khách hàng học IELTS để ra trường?\n- Khách hàng học IELTS để xin việc?\n- Kế hoạch ngắn hạn? dài hạn?"},
                {id: 6, value: "Quyết định và lựa chọn", placeholder: "- Khách hàng còn phân vân giữa các lựa chọn?\n- Tại sao chưa quyết định, cần thêm thuyết phục về điều gì?"},
                {id: 7, value: "Khoảng cách", placeholder: "- Khách hàng ở xa trung tâm? ...km?\n- Khách hàng lo lắng về vấn đề đi lại"},
                {id: 8, value: "Nỗi sợ", placeholder: "- Khách hàng không học được?\n- Sợ chi phí học cao?\n- Phân vân giữa học chứng chỉ/ngôn ngữ?"},
                {id: 9, value: "Khác", placeholder: "- Sở thích, Tính cách, Thói quen, Mong muốn"},
            ],
        }
    },

    methods: {
        getHotKeyLabel(id) {
            const item = this.phimNongDeFine.find(i => i.id === id);
            return item ? item.value : '';
        },

        getHotKeyPlaceholder(id) {
            const item = this.phimNongDeFine.find(i => i.id === id);
            return item ? item.placeholder : '';
        }
    }
}
</script>

<style scoped>

</style>
